import { Link } from 'react-router-dom';

/** 403 page shown when a staff user reaches an owner-only route. */
export default function Forbidden() {
  return (
    <div data-testid="forbidden-page" className="py-20 text-center">
      <p className="text-5xl font-bold text-gray-300">403</p>
      <h1 className="mt-4 text-2xl font-bold text-gray-900">Not permitted</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-gray-500">
        This area is restricted to owner accounts. If you need access, ask an
        owner to update your role.
      </p>
      <Link
        to="/dashboard"
        className="mt-6 inline-block rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
